"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Linkedin;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import React from 'react';
// export default function Linkedin(props) {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={100} height={100} {...props}>
//       <title>LinkedIn</title>
//       <g id="Social_media" data-name="Social media">
//         <path id="linkedin" d="M27.907,89.991H11.321v-53.4H27.907Zm62.075,0H73.432V64c0-6.195-.125-14.14-8.623-14.14-8.623,0-9.944,6.731-9.944,13.693V89.991H38.3v-53.4H54.2v7.284h.232c2.214-4.195,7.624-8.623,15.693-8.623C86.911,35.253,90,46.3,90,60.658V89.991ZM29.21,19.614a9.605,9.605,0,1,0-9.6,9.694A9.608,9.608,0,0,0,29.21,19.614Z" />
//       </g>
//     </svg>
//   );
// }
function Linkedin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22"
  }, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".linkedin0{fill:#FFFFFF;}"
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "linkedin0",
    d: "M6.7,18.4V8.5H3.4v9.9H6.7L6.7,18.4z M5,7.2c1.1,0,1.9-0.8,1.9-1.7c0-1-0.7-1.7-1.8-1.7c-1.1,0-1.9,0.7-1.9,1.7 C3.2,6.4,3.9,7.2,5,7.2L5,7.2L5,7.2z M8.5,18.4h3.3v-5.5c0-0.3,0-0.6,0.1-0.8c0.2-0.6,0.8-1.2,1.7-1.2c1.2,0,1.7,0.9,1.7,2.2v5.3 h3.3v-5.7c0-3-1.6-4.5-3.8-4.5c-1.8,0-2.6,1-3,1.7h0V8.5H8.5C8.6,9.4,8.5,18.4,8.5,18.4L8.5,18.4z"
  }));
}